const { isObject } = require('./is-object')

/**
 * @param {object} obj
 */
function removeNullValuesFromObject (obj) {
  if (!obj || !isObject(obj)) return

  return Object.entries(obj)
    .filter(([_, v]) => v !== null)
    .reduce(
      (acc, [k, v]) => ({
        ...acc,
        [k]: v === Object(v)
          ? removeNullValuesFromObject(v)
          : v
      }),
      {}
    )
}

module.exports = { removeNullValuesFromObject }
